export const SUPPORTED_LANGUAGES = [
    {
        code: 'pl',
        translationKey: 'common.languages.pl',
        nativeLabel: 'PL',
    },
    {
        code: 'en',
        translationKey: 'common.languages.en',
        nativeLabel: 'EN',
    },
];

export const DEFAULT_LANGUAGE = SUPPORTED_LANGUAGES[0].code;

export const isLanguageSupported = locale => SUPPORTED_LANGUAGES.some(language => language.code === locale);
